export default {
    userReadAllBegin(state) {
        state.loading = true;
        state.error = null;
    },

    userReadAllSuccess(state, data) {
        state.data = data.list;
        state.total = data.total !== undefined ? data.total : 0;
        state.loading = false;
    },

    userReadAllErr(state, err) {
        state.error = err;
        state.loading = false;
    },

    userAddBegin(state) {
        state.loading = true;
        state.error = null;
    },

    userAddSuccess(state, data) {
        state.data.push(data);
        state.loading = false;
    },

    userAddErr(state, err) {
        state.error = err;
        state.loading = false;
    },

    userTokenBegin(state) {
        state.loading = true;
        state.error = null;
        state.token = null;
    },

    userTokenSuccess(state, data) {
        console.log('userTokenSuccess', data);
        state.token = data;
        state.loading = false;
    },

    userTokenAddSuccess(state, data) {
        state.token = data;
        state.loading = false;
    },

    userTokenErr(state, err) {
        state.error = err;
        state.loading = false;
    },

    userTokenUpdateSuccess(state, data) {
        state.token = data;
        state.loading = false;
    },

    userTokenUpdateBegin(state) {
        state.loading = true;
        state.error = null;
    },

    userTokenUpdateErr(state, err) {
        state.error = err;
        state.loading = false;
    },
};